import crypto from 'crypto'
export default {
  datafeeds: null,
  // 登录密码格式限制
  // validatePassword(password) {
  //   var reg = /^[A-Za-z0-9\.]+$/
  //   if (!reg.test(password)) {
  //     Toast('密码必须为数字或字母')
  //     return false
  //   } else if (password.length < 8 || password.length > 16) {
  //     Toast('密码错误：请输入8至16位密码！')
  //     return false
  //   }
  //   return true
  // },
  // MD5加密
  getmd5(data) {
    var a
    var md5 = crypto.createHash('md5')
    md5.update(data)
    a = md5.digest('hex')
    return a
  },
  formatDate: {
    format: function(timestamp) {
      // var timezone = 8; //目标时区时间，东八区
      // var offset_GMT = new Date().getTimezoneOffset();
      // var offset_GMT_Time = -offset_GMT/60;
      // var newTimer = Number(timestamp)-(offset_GMT_Time-timezone)*60*60*1000
      const date = new Date(timestamp)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let min = date.getMinutes()
      let sec = date.getSeconds();
      [year, month, day, hour, min, sec] = [year, month, day, hour, min, sec].map(
        item => (item < 10 ? '0' + item : item)
      )
      return `${year}-${month}-${day} ${hour}:${min}:${sec}`
    },
    formatnewDay(timestamp) {
      var date = new Date(timestamp)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate();
      [year, month, day] = [year, month, day].map((item) =>
        item < 10 ? '0' + item : item
      )
      return `${year}${month}${day}`
    },
    formatMD: function(timestamp) {
      // var timezone = 8; //目标时区时间，东八区
      // var offset_GMT = new Date().getTimezoneOffset();
      // var offset_GMT_Time = -offset_GMT/60;
      // var newTimer = Number(timestamp)-(offset_GMT_Time-timezone)*60*60*1000
      const date = new Date(timestamp)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let min = date.getMinutes()
      let sec = date.getSeconds();
      [year, month, day, hour, min, sec] = [year, month, day, hour, min, sec].map(
        item => (item < 10 ? '0' + item : item)
      )
      return `${hour}:${min} ${month}/${day} `
    }
  },
  getTimes(str) {
    let len = 0
    try {
      len = str.toString().split('.')[1].length // 计算出小数点后有几位
    } catch (e) {
      len = 0 // 小数点后没有东西，就默认为零位
    }
    const m = Math.pow(10, len)
    return m
  },
  // 截取图片
  getSmallBase64(url, callback) {
    var Img = new Image()
    var dataURL = ''
    var drawEncoderOptions = 40000.0 / url.length > 1 ? 0.92 : 40000.0 / url.length
    Img.src = 'data:image/jpeg;base64,' + url
    Img.onload = function() { // 异步
      var canvas = document.createElement('canvas')
      var width = Img.width
      var height = Img.height
      canvas.width = 300
      canvas.height = 300.0 * (height / width)
      canvas.getContext('2d').drawImage(Img, 0, 0, 300, 300 * (height / width))
      dataURL = canvas.toDataURL('image/jpeg')
      const i = dataURL.indexOf(',') // 截取data:image/png;base64,后的内容
      const imageName = dataURL.substring(i + 1, dataURL.length) // 把图片的二进制流付给表单ruleFinancingForm里面的idImage
      callback ? callback(imageName, drawEncoderOptions) : null
    }
  },
  floatAdd(arg1, arg2) {
    let r1 = 0
    let r2 = 0
    let m = 0
    try { r1 = arg1.toString().split('.')[1].length } catch (e) { r1 = 0 }
    try { r2 = arg2.toString().split('.')[1].length } catch (e) { r2 = 0 }
    const n = Math.max(r1, r2)
    m = Math.pow(10, n)
    return ((arg1 * m + arg2 * m) / m).toFixed(n)
  },

  floatSub(arg1, arg2) {
    let r1 = 0
    let r2 = 0
    let m = 0
    let n = 0
    try { r1 = arg1.toString().split('.')[1].length } catch (e) { r1 = 0 }
    try { r2 = arg2.toString().split('.')[1].length } catch (e) { r2 = 0 }
    m = Math.pow(10, Math.max(r1, r2))
    // last modify by deeka
    // 动态控制精度长度
    n = (r1 >= r2) ? r1 : r2
    return ((arg1 * m - arg2 * m) / m).toFixed(n)
  },

  floatMul(arg1, arg2) {
    if (arg1 && arg2) {
      let m = 0
      // s1 = Number(arg1).toString(),
      // s2 = Number(arg2).toString();
      const s1 = arg1.toString()
      const s2 = arg2.toString()
      try { m += s1.split('.')[1].length } catch (e) {}
      try { m += s2.split('.')[1].length } catch (e) {}
      return (Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)).toFixed(m)
    } else {
      return 0
    }
  },

  // 浮点数除法运算
  floatDiv(arg1, arg2) {
    arg1 = Number(arg1)
    arg2 = Number(arg2)
    var t1 = 0
    var t2 = 0
    var r1; var r2
    try { t1 = arg1.toString().split('.')[1].length } catch (e) {}
    try { t2 = arg2.toString().split('.')[1].length } catch (e) {}
    r1 = Number(arg1.toString().replace('.', ''))
    r2 = Number(arg2.toString().replace('.', ''))
    let n = 0
    if (t2 > t1) {
      n = t2 - t1
    } else {
      n = t1 - t2
    }
    return ((r1 / r2) * Math.pow(10, t2 - t1)).toFixed(n)
  },
  // url转UrlEncode
  UrlEncode(str) {
    return this.transform(str)
  },

  transform(s) {
    var hex = ''
    var i, t

    for (i = 0; i < s.length; i++) {
      t = this.hexfromdec(s.charCodeAt(i))
      if (t == '25') {
        t = ''
      }
      hex += '%' + t
    }
    return hex
  },

  hexfromdec(num) {
    if (num > 65535) { return ('err!') }
    const first = Math.round(num / 4096 - 0.5)
    const temp1 = num - first * 4096
    const second = Math.round(temp1 / 256 - 0.5)
    const temp2 = temp1 - second * 256
    const third = Math.round(temp2 / 16 - 0.5)
    const fourth = temp2 - third * 16
    return ('' + this.getletter(third) + this.getletter(fourth))
  },

  getletter(num) {
    if (num < 10) {
      return num
    } else {
      if (num == 10) { return 'A' }
      if (num == 11) { return 'B' }
      if (num == 12) { return 'C' }
      if (num == 13) { return 'D' }
      if (num == 14) { return 'E' }
      if (num == 15) { return 'F' }
    }
  },
  toThousands(num) {
    if (typeof num === 'number' && !isNaN(num)) {
      var result = ''
      num = Number(num.toString() || 0).toFixed(2)
      var numAry = num.toString().split('.')
      var preNum = numAry[0]
      var lastNum = numAry[1]
      while (preNum.length > 3) {
        result = ',' + preNum.slice(-3) + result
        preNum = preNum.slice(0, preNum.length - 3)
      }
      if (preNum) {
        result = preNum + result
      }
      result = result + '.' + lastNum
      return result
    } else {
      return num
    }
  },
  exactPointTwo(num, arrIndex, arrProperty) {
    let newVal
    num = Number(num)
    if (num < 0) {
      num = num.toString().substring(1)
      newVal = Number(num.toString().match(/^\d+(?:\.\d{0,2})?/)) * -1
    } else {
      newVal = Number(num.toString().match(/^\d+(?:\.\d{0,2})?/))
    }
    // 整数自动补0
    if (newVal.toString().indexOf('.') == -1) {
      newVal += '.00'
    }
    const len = newVal.toString().indexOf('.') + 1
    // 1位数自动补0
    if (newVal.toString().substring(len).split('').length == 1) {
      newVal += '0'
    }
    if (arrProperty) {
      arrIndex[arrProperty] = newVal
    }
    return newVal
  },
  // 获取时区并返回tradingView时区字符串
  getTimeZoneStr() {
    var offset_GMT = new Date().getTimezoneOffset()
    var offset_GMT_Time = -offset_GMT / 60// 东正 西负
    switch (offset_GMT_Time) {
      case -11:
      {
        return 'Pacific/Honolulu' // wu1
      }
      case -10:
      {
        return 'Pacific/Honolulu'
      }

      case -9:
      {
        return 'America/Juneau'
      }

      case -8:
      {
        return 'America/Los_Angeles'
      }

      case -7:
      {
        return 'America/Phoenix'
      }

      case -6:
      {
        return 'America/El_Salvador'
      }

      case -5:
      {
        return 'America/Bogota'
      }

      case -4:
      {
        return 'America/Caracas'
      }

      case -3:
      {
        return 'America/Sao_Paulo'
      }

      case -2:
      {
        return 'America/Sao_Paulo' // wu
      }

      case -1:
      {
        return 'Pacific/Honolulu'
      }

      case 0:
      {
        // return 'Atlantic/Reykjavik'
        return 'Etc/UTC'
      }

      case 1:
      {
        return 'Europe/Madrid'
      }

      case 2:
      {
        return 'Africa/Cairo'
      }

      case 3:
      {
        return 'Europe/Moscow'
      }

      case 4:
      {
        return 'Asia/Dubai'
      }

      case 5:
      {
        return 'Asia/Kolkata'
      }

      case 5.5:
      {
        return 'Asia/Kolkata'
      }

      case 6:
      {
        return 'Asia/Almaty'
      }

      case 7:
      {
        return 'Asia/Bangkok'
      }

      case 8:
      {
        return 'Asia/Hong_Kong'
      }

      case 9:
      {
        return 'Asia/Tokyo'
      }

      case 10:
      {
        return 'Australia/Sydney'
      }

      case 11:
      {
        return 'Australia/Sydney' // 所罗门群岛
      }

      case 12:
      {
        return 'Pacific/Auckland'
      }

      default:
      {
        return 'Etc/UTC'
      }
    }
  }

}
